import { StackView, Divider, Button } from '@planningcenter/tapestry-react';
import React from 'react';
import 'stream-chat-react';
import { getPrimaryButtonStyleOverrides } from '../../utils/index.js';
import { useChat } from '../../hooks/use_chat.js';
import '../../chat_api_context.js';
import { useChatAppGrants } from '../../hooks/use_chat_app_grants.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import 'stream-chat';
import { ScrollContainer } from '../../vendor/topbar/components/scroll_container.js';
import { LoadingErrorIndicator } from './loading_error_indicator.js';

const List = (props) => {
    const { children, error = null, loading } = props;
    const { navigation } = useChat();
    const chatAppGrants = useChatAppGrants();
    const displayNewConversationButton = chatAppGrants.canCreateChat("Services") ||
        chatAppGrants.canCreateChat("Groups");
    if (error)
        return React.createElement(LoadingErrorIndicator, null);
    if (loading)
        return null;
    return (React.createElement(StackView, { grow: 1, shrink: 1 },
        React.createElement(ScrollContainer, null, children),
        React.createElement(Divider, null),
        React.createElement(StackView, { padding: 2, alignment: "stretch" }, displayNewConversationButton && (React.createElement(Button, { "aria-label": "Switch to new conversation", onClick: navigation.switchToNewChatShortcutsView, ...getPrimaryButtonStyleOverrides() }, "New conversation")))));
};

export { List };
//# sourceMappingURL=list.js.map
